import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import { useParams } from 'react-router-dom'
import ClimaCheckService from '~/api/services/climaCheck'
import Results from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/Results'

interface Props {
  farmerId: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
}

const PreviewModal: React.FC<Props> = (props) => {
  const { farmerId, handleClose, uniqueId } = props
  const { t } = useTranslation()
  const { id } = useParams()

  const [submitPreviewData, setSubmitPreviewData] = useState({
    cowResults: null,
    heiferResults: null
  })
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (farmerId) {
      fetchPreviewData()
    }
  }, [farmerId])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await ClimaCheckService.getClimaChDairyResults(id, farmerId)
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(farmerId)}
    style={{ width: '80%' }}
    isLoading={isBusy}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      <Results results={submitPreviewData} removeMargin />
    </>}
    handleClose={() => handleClose()}
    textClose={t('Close')}
  />

}
export default PreviewModal